<template>
  <v-dialog v-model="modal" persistent width="290px">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="value"
        :label="label"
        hide-details="auto"
        required
        readonly
        dense
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-time-picker v-model="time" color="primary" scrollable ampm-in-title>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
      <v-btn text color="primary" @click="onTimeInput(time)">OK</v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },

    value: {
      type: String,
      required: true,
      validator: value => {
        // hh:mm AM/PM
        const apiTimeFormat = /\d{2}:\d{2} am|pm/i;
        return apiTimeFormat.test(value);
      }
    }
  },

  data() {
    return {
      modal: false,
      time: null
    };
  },

  watch: {
    value: "setInputData"
  },

  mounted() {
    this.setInputData(this.value);
  },

  methods: {
    setInputData(value) {
      if (value) this.time = this.toIsoTime(value);
      else this.time = "00:00";
    },

    toIsoTime(time) {
      const match = /(?<h>\d{2}):(?<m>\d{2}) (?<p>am|pm)/im.exec(time);
      let { h, m, p } = match.groups;

      if (p.toUpperCase() === "PM") h = parseInt(h) + 12;
      return [String(h).padStart(2, "0"), m.padStart(2, "0")].join(":");
    },

    toApiTime(time) {
      const match = /(?<h>\d{2}):(?<m>\d{2})/m.exec(time);
      let { h, m } = match.groups;
      let p = "AM";

      if (h > 12) {
        p = "PM";
        h = parseInt(h) - 12;
      }
      return `${String(h).padStart(2, "0")}:${m.padStart(2, "0")} ${p}`;
    },

    onTimeInput(time) {
      this.$emit("input", this.toApiTime(time));
      this.modal = false;
    }
  }
};
</script>
